import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import {showInternationalUpdated} from '../settingsSlice';

export const useSetShowInternational = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (showInternational: boolean) => {
      dispatch(showInternationalUpdated(showInternational));
    },
    [dispatch],
  );
};
